// extracted by mini-css-extract-plugin
export default {"root":"neon-border_root__2fYW4"};